import MoneyInput from 'common/components/moneyInput/MoneyInput';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { useContext } from 'react';
import { LinesDataProvider } from '../../../../LinesDataProvider';
import ExpressionSystem from 'common/components/expressionButton/ExpressionSystem';
import { getExpressionParameters } from '../../../../utils';
import { BudgetLineDto } from 'api/budgets/models/BudgetDto';

interface Props {
    parameter: BudgetLineParameterDto;
    line: BudgetLineDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterNumber({ parameter, line, disabled, onChange }: Props): JSX.Element | null {
    const { units } = useContext(LinesDataProvider);
    const unitPrefix = units.find(x => x.id === parameter.number?.unitId)?.symbol;

    return (
        <MoneyInput
            value={parameter.number?.number ?? null}
            onBlur={(v) => {
                const tolerance = 0.000001;
                const currentValue = parameter.number?.number ?? 0;
                const newValue = v ?? 0;
                const isDifferent = Math.abs(currentValue - newValue) > tolerance;
                onChange({
                    number: {
                        ...(parameter.number ?? {}),
                        number: newValue,
                        numberExpression: isDifferent ? null : parameter.number?.numberExpression
                    }
                }, false);
            }}
            disabled={disabled}
            hideUnitsDrop={!unitPrefix}
            unitPrefix={unitPrefix}
            expressionButton={{
                title: ExpressionSystem.formatParameterName([parameter.parameterName ?? '']),
                value: parameter.number?.numberExpression ?? '',
                loadParameters: () => getExpressionParameters(line.key),
                onChange: (expr, value) => onChange({ number: { ...(parameter.number ?? {}), number: value ?? 0, numberExpression: expr } }, false)
            }}
        />
    );
}

export default ParameterNumber;
